import { render, staticRenderFns } from "./LevelMetricCell.vue?vue&type=template&id=2fc3fc76&scoped=true"
import script from "./LevelMetricCell.vue?vue&type=script&lang=js"
export * from "./LevelMetricCell.vue?vue&type=script&lang=js"
import style0 from "./LevelMetricCell.vue?vue&type=style&index=0&id=2fc3fc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3fc76",
  null
  
)

export default component.exports